import { AuthState } from 'contexts/Auth';
import { getAuthHeader } from 'util/authHeader';

import { ENDPOINT } from './constants';

export default (auth: AuthState) => {
  const url = new URL(ENDPOINT, window.location.origin);

  url.searchParams.append('referrer', encodeURIComponent(document.referrer));

  const headers: Record<string, string> = {
    Accept: 'application/json',
  };

  if (auth.token) {
    headers.Authorization = getAuthHeader(auth)!;
  }

  return fetch(url.toString(), {
    credentials: 'same-origin',
    headers,
  });
};
